import LSSuffix from '../../../../config/LSSuffix.js';

const getDynamicLSKey = (key) => `${key}${LSSuffix.getSuffix()}`;

export { getDynamicLSKey };
